<template>
  <v-container style="max-width: 100vw; height: 60vh;">
    <v-row
      style="
        display: flex;
        justify-content: end;
        margin-right: 30px;
        margin-top: 20px;
      "
    >
      <v-switch color="black" v-model="disable3dSundae" inset></v-switch
      ><span style="padding-top: 1.1rem; color: black; font-size: large"
        >3D</span
      >
    </v-row>

    <div v-if="cards.length > 0">
      <carousel-3d
        :controls-visible="true"
        :clickable="false"
        :disable3d="!disable3dSundae"
        :space="!disable3dSundae ? 356 : 250"
        :width="340"
        :height="480"
        :border="1.5"
      >
        <slide v-for="(card, i) in cards" :index="i" :key="card.projectID">
          <figure
            class="zoom"
            style="
              cursor: pointer;
              background-color: aliceblue;
              border-radius: 30px;
            "
            @click="routerPage(card)"
          >
            <img
              :src="card.src"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              style="
                width: 100%;
                height: 480px;
                object-fit: scale-down;
                background: #fff;
              "
            />
            <figcaption>
              {{ card.projectName }}
            </figcaption>
          </figure>
        </slide>
      </carousel-3d>
    </div>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import enurl from "@/api/environment";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Carousel3d, Slide } from "vue-carousel-3d";

export default {
  name: "ProjectSite",
  components: {
    Carousel3d,
    Slide,
  },
  data() {
    return {
      url: enurl.apiUrl,
      urlReport: enurl.apiReport,
      LoadingDialog: false,
      AlertDialog: false,
      disable3dSundae: true,
      TypeAlert: null,
      MessageAlert: "",
      reportMenu: [],
      reportMenuCarpark: [],
      MenuPermission: [],
      cards: [],
      model: null,
      cardsData: [],
      ProjectSiteList: [],
    };
  },
  
  async mounted() {
    await this.getDataProjectSiteFromRoleID();
  },

  computed: {},

  watch: {
    disable3dSundae() {
      const d = new Date();
      d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      if (
        this.disable3dSundae == null ||
        this.disable3dSundae == "true" ||
        this.disable3dSundae == true
      ) {
        document.cookie = "3D" + "=" + true + ";" + expires + ";path=/";
        this.disable3dSundae = true;
      } else {
        document.cookie = "3D" + "=" + false + ";" + expires + ";path=/";
        this.disable3dSundae = false;
      }
    },
  },
  methods: {
    getDataProjectSiteFromRoleID() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}Management/getDataProjectSiteFromRoleID`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ProjectSiteList = response.data.data;
            self.cards = self.ProjectSiteList.map((item) => ({
              ...item,
              src: item.logoImage ? `data:image/svg+xml;base64,${item.logoImage}` : require("@/assets/logoFS.svg"),
              flex: 3,
            }));
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    routerPage(page) {
      localStorage.setItem("ProjectSiteID", page.projectID);
      localStorage.setItem("ProjectSiteName", page.projectName);
      this.$router.push("/MainMenu");
    },
  },
};
</script>
<style scoped>
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
  color: black;
}
@font-face {
  font-family: "Roboto", sans-serif;
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333 !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loading-box {
  width: 150px;
  height: 100px;
  border: 5px solid #f1f1f1;
  /* margin: 100px auto; */
  position: relative;
}

.inter-load {
  width: 100px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.zoom {
  z-index: 99;
  transition: transform 0.3s;
}

.zoom:hover {
  transform: scale(1.05);
}

.carousel-3d-container figure {
  margin: 0;
}

.carousel-3d-container figcaption {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  bottom: 0;
  position: absolute;
  bottom: 0;
  padding: 15px;
  font-size: 20px;
  min-width: 100%;
  box-sizing: border-box;
  text-align: center;
}

.carousel-3d-slide {
  border-radius: 10px;
  border-color: grey;
}
.custom-red .v-input--selection-controls__input div {
  color: #6a1b9a;
}
</style>
